<template>
  <div
    style="{styles.wrapper(true)}"
    id="mediaLibraryContainer"
    v-if="marketsLoaded"
  >
    <nav :style="styles.nav">
      <img :src="getFlagUrl(getActiveMarket)">
      &nbsp;
      <div class="rule__control-group rule__control-group--select">
        <select
          v-if="marketsLoaded && markets.length"
          @change="changeMarket"
          ref="marketDropdown"
          class="form__select"
          :value="getActiveMarket._id"
          :style="styles.marketSelect"
        >>
          <option v-for="(market, index) in markets" :value="market._id">{{ market.title }}</option>
        </select>
      </div>
      <div :style="styles.navInputWrapper">
        <i class="glyphicon glyphicon-search" :style="styles.navInputIcon"></i>
        <input
          :style="styles.navInput"
          type="text"
          @focus="navigateToMediaSearch"
          placeholder="Search"
        >
      </div>
      <button class="button__action" @click="refreshMedia" :style="styles.toggleUploadModalButton">
        <i class="glyphicon glyphicon-refresh" :style="styles.uploadIcon"></i>&nbsp;
        Reload
      </button>
      <button
        class="button__action UppyModalToggle"
        @click="toggleUploadMediaModal(true)"
        :style="styles.toggleUploadModalButton"
      >
        <i :style="styles.uploadIcon" class="glyphicon glyphicon-plus"></i>&nbsp;
        Upload New
      </button>
      <div class="UppyDashboardContainer"/>
    </nav>
    <div
      id="libraryWrapper"
      :style="styles.libraryWrapper"
    >
      <LibraryGrid>
        <div class="view-explanation">
          <h1>Media</h1>
          <p class="no-bottom-margin">The media library is where you can manage media items, the markets they are available in, what product groups they belong in, and configure many more additional settings and properties. Media is available to view in-app within its active market(s).</p>
        </div>
        <div class="content-filters-wrapper">
          <select
            @change="handleGroupChange"
          >
            <option value="all" selected>All Products</option>
            <option
              v-if="productGroups && productGroups.length"
              v-for="group in productGroups"
              :value="group._id"
            >
              {{ group.title }}
            </option>
          </select>
        </div>
        <vue-tabs
          activeTextColor="#09a3ed"
          v-if="filteredItems"
          @tab-change="handleTabChange"
        >
          <v-tab
            v-if="getMediaTabs && getMediaTabs.length"
            v-for="tab in getMediaTabs"
            :key="`library-${tab._id}`"
            :title="tab.title"
          >
            <div class="inner-tab">
                <draggable :options="{draggable:'.item'}" @end="updatePosition" v-model="filteredItems">
                    <MediaRow
                        class="item"
                        v-if="mediaLoaded"
                        :contentType="media.contentType"
                        :title="media.title"
                        :isTop="index === 0"
                        :key="index"
                        :data-id="media._id"
                        :id="media._id"
                        :onClick="selectActiveMedia"
                        :media="media"
                        :selectedMlId="selectedMlId"
                        :selectedPgId="selectedPgId"
                        :refreshMedia="refreshMedia"
                        :src="media.thumbnail"
                        :isMediaLibrary="true"
                        v-for="(media, index) in filteredItems"
                    />
                </draggable>
              <div v-if="mediaLoaded && !filteredItems.length">
                <p :style="styles.noMedia">No media.</p>
              </div>
            </div>
          </v-tab>
          <v-tab
            v-if="mediaLibraries && mediaLibraries.length"
            :key="`library-uncategorized`"
            title="(Uncategorized)"
          >
            <div class="inner-tab">
                <draggable :options="{draggable:'.item'}" @end="updatePosition" v-model="filteredItems">
                    <MediaRow
                        class="item"
                        v-if="mediaLoaded"
                        :contentType="media.contentType"
                        :title="media.title"
                        :isTop="index === 0"
                        :key="index"
                        :data-id="media._id"
                        :id="media._id"
                        :onClick="selectActiveMedia"
                        :media="media"
                        :selectedMlId="selectedMlId"
                        :selectedPgId="selectedPgId"
                        :refreshMedia="refreshMedia"
                        :src="media.thumbnail"
                        :isMediaLibrary="true"
                        v-for="(media, index) in filteredItems"
                    />
                </draggable>
              <div v-if="mediaLoaded && !filteredItems.length">
                <p :style="styles.noMedia">No media.</p>
              </div>
            </div>
          </v-tab>
        </vue-tabs>
      </LibraryGrid>
    </div>
    <Spinner v-if="!mediaLoaded"/>
  </div>
</template>

<script>
import 'vue-nav-tabs/themes/paper.css';
import { postResource } from '../../services/Utils';
import { VueTabs, VTab } from 'vue-nav-tabs';
import draggable from 'vuedraggable';
import FineUploaderS3 from 'fine-uploader-wrappers/s3';
import LibraryGrid from '../general/LibraryGrid';
import MediaCard from '../general/MediaCard';
import MediaRow from '../general/MediaRow';
import Services from '../../services/Services';
import Spinner from '../general/Spinner';
import store from '../../store';
import VueNotifications from 'vue-notifications';
export default {
  name: 'mediaLibrary',
  components: {
    draggable,
    Spinner,
    LibraryGrid,
    MediaCard,
    VueTabs,
    VTab,
    MediaRow
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  computed: {
    // Artifact of original client side filtering search
    filteredItems: {
        get() {
            const arr = store.getters.getMedia;
            return arr;
        },
        set(items) {
            store.commit('setMedia', items);
        }
    },
    isSelectedItem(item) {
      const arr = store.getters.getSelectedMedia;
      if (arr.includes(item)) return true;
      return false;
    },
    mediaLoaded() {
      return store.getters.checkMediaLoaded;
    },
    marketsLoaded() {
      return store.getters.checkMarketsLoaded;
    },
    markets() {
      return store.getters.getMarkets;
    },
    mediaLibraries() {
      return store.getters.getAllMediaLibraries;
    },
    productGroups() {
      return store.getters.getAllProductGroups;
    },
    getActiveMarket() {
      return store.getters.getActiveMarket;
    },
    getMediaTabs() {
        return store.getters.getMediaTabs;
    },
    getActiveMediaTab() {
        return store.getters.getActiveMediaTab;
    }
  },
  methods: {
    updatePosition(event){
        const mediaId = this.filteredItems[event.newIndex]._id;

        const update = {};

        if(this.selectedPgId) {
            update.tabId = this.selectedPgId;
        } else {
            update.tabId = this.selectedMlId;
        }

        update.pos = event.newIndex;

        // new index logic
        let position = 0;
        if(event.newIndex === 0){
            // new first item
            const topIndex = this.filteredItems[1].positions[update.tabId];
            position = topIndex + 1000;
        } else if (event.newIndex === this.filteredItems.length - 1){
            // new last item
            const bottomIndex = this.filteredItems[this.filteredItems.length - 2].positions[update.tabId];
            position = bottomIndex - 1;
        } else {
            // item in between
            const aboveIndex = event.newIndex - 1;
            const belowIndex = event.newIndex + 1;
            const abovePosition = this.filteredItems[aboveIndex].positions[update.tabId];
            const belowPosition = this.filteredItems[belowIndex].positions[update.tabId];
            position = Math.floor(Math.random() * belowPosition) + abovePosition;
            position = Math.floor(Math.random() * (abovePosition - belowPosition + 1)) + belowPosition;
        }

        update.pos = position;

        postResource('/v1/media/updatePosition', `mediaId=${mediaId}`, update)
            .then(res => {
                 this.showSuccessMsg({
                    message: 'New media order saved!'
                });
            })
            .catch(error => {
                this.showErrorMsg({
                    message: 'An error occurred. Please try again.'
                });
            })
    },
    changeMarket() {
      const marketId = this.$refs.marketDropdown.value;
      const markets = store.getters.getMarkets;
      const market = markets.filter(m => m._id === marketId)[0];
      store.commit('setActiveMarket', market);
      this.refreshMedia();
    },
    onScroll() {
      const el = document.getElementById('scrollWrapper')
      if (el.scrollTop + el.clientHeight >= document.getElementById('mediaLibraryContainer').clientHeight) {
        this.loadMoreMedia();
      }
    },
    handleTabChange(index) {
      store.commit('setMediaLoadedStatus', false);
      const tabs = this.getMediaTabs;
      const activeTab = tabs[index];
      const market = store.getters.getActiveMarket;
      store.commit('setActiveMediaTab', (activeTab ? activeTab : null));

      if (activeTab) {
        if (activeTab._id === 'featured') {
          this.selectedMlId = 'featured'
          this.selectedPgId = null;
          this.last = null;
          this.moreMedia = null;
          return Services.getMediaByMarket(market._id, 'featured', false, false, false, (res) => {
            this.moreMedia = res.more;
          });
        } else if (activeTab.type === 'mediaLibrary') {
          this.selectedMlId = activeTab._id;
          this.selectedPgId = null;
          this.last = null;
          this.moreMedia = null;
          return Services.getMediaByMarket(market._id, activeTab._id, false, false, false, (res) => {
            this.moreMedia = res.more;
          });
        } else if (activeTab.type === 'productGroup') {
          this.selectedPgId = activeTab._id;
          this.selectedMlId = null;
          this.last = null;
          this.moreMedia = null;
          return Services.getMediaByMarket(market._id, false, activeTab._id, false, false, (res) => {
            this.moreMedia = res.more;
          });
        }
      } else if (!activeTab && (index === tabs.length)) {
        this.selectedPgId = null;
        this.selectedMlId = 'none';
        this.last = null;
        this.moreMedia = null;
        return Services.getMediaByMarket(market._id, 'none', false, false, false, (res) => {
          this.moreMedia = res.more;
        });
      }

    },
    handleLibraryChange(id) {
      const mlId = id;
      const market = store.getters.getActiveMarket;
      if (mlId === 'all') {
        this.selectedMlId = null;
        this.last = null;
        this.moreMedia = null;
        Services.getMediaByMarket(market._id, false, this.selectedPgId, false, false, (res) => {
          this.moreMedia = res.more;
        });
      } else if (mlId === 'none') {
        this.selectedMlId = 'none';
        this.last = null;
        this.moreMedia = null;
        Services.getMediaByMarket(market._id, 'none', this.selectedPgId, false, false, (res) => {
          this.moreMedia = res.more;
        });
      } else {
        this.selectedMlId = mlId;
        this.last = null;
        this.moreMedia = null;
        Services.getMediaByMarket(market._id, mlId, this.selectedPgId, false, false, (res) => {
          this.moreMedia = res.more;
        });
      }
    },
    handleGroupChange(e) {
      const pgId = e.target.value;
      const market = store.getters.getActiveMarket;
      if (pgId === 'all') {
        this.selectedPgId = null;
        this.last = null;
        this.moreMedia = null;
        Services.getMediaByMarket(market._id, this.selectedMlId, false, false, false, (res) => {
          this.moreMedia = res.more;
        });
      } else {
        this.selectedPgId = pgId;
        this.last = null;
        this.moreMedia = null;
        Services.getMediaByMarket(market._id, this.selectedMlId, pgId, false, false, (res) => {
          this.moreMedia = res.more;
        });
      }
    },
    loadMoreMedia() {
      if (this.moreMedia) {
        const media = this.filteredItems;
        let count = 0;
        if(this.selectedMlId){
            count = media[media.length - 1].positions[this.selectedMlId] - 1;
        } else {
            count = media[media.length - 1].positions[this.selectedPgId] - 1;
        }
        this.last = count;
        Services.getMediaByMarket(store.getters.getActiveMarket._id, this.selectedMlId, this.selectedPgId, count, this.moreMedia, (res) => {
          this.moreMedia = res.more;
        });
      }
    },
    navigateToMediaSearch() {
      this.$router.push('search/media');
    },
    refreshMedia() {
      store.commit('setMediaLoadedStatus', false);
      this.last = null;
      this.moreMedia = null;
      Services.getMediaByMarket(store.getters.getActiveMarket._id, this.selectedMlId, this.selectedPgId, false, false, (res) => {
        this.moreMedia = res.more;
      });
    },
    toggleUploadMediaModal(bool) {
      store.commit('showMediaUploadModal', bool);
    }
  },
  data() {
    return {
      query: '',
      selectActiveMedia: Services.selectActiveMedia,
      toggleUploadMedia: Services.toggleUploadMedia,
      getFlagUrl: Services.getFlagUrl,
      selectedMlId: 'featured',
      selectedPgId: null,
      last: null,
      moreMedia: true,
      canDelete: true,
      unsavedEdits: {
        description: false,
        title: false,
        productGroups: false,
        generalUses: false
      },
      styles: {
        wrapper: loaded => ({
          display: 'flex',
          flexFlow: 'row nowrap',
          justifyContent: loaded ? 'flex-start' : 'center',
          alignItems: loaded ? 'flex-start' : 'center',
          height: '100vh',
          background: '#f5f5f5'
        }),
        libraryWrapper: {
          background: '#f5f5f5',
          paddingBottom: '20px'
        },
        nav: {
          position: 'fixed',
          top: '0',
          left: '200px',
          right: '0',
          background: 'rgba(255,255,255,0.9)',
          borderBottom: '1px solid #eee',
          boxShadow: '0 0 20px 5px rgba(0,0,0,0.1)',
          height: '60px',
          zIndex: '99',
          padding: '10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        marketSelect: {
          width: '250px',
          fontSize: '1em',
          fontWeight: 700,
          // padding: '10px',
          height: '40px',
          boxSizing: 'border-box',
          margin: 'auto auto auto 0'
        },
        navInputWrapper: {
          flex: '0 0 auto',
          width: 'auto',
          padding: '8px',
          margin: 'auto 0 auto auto',
          background: '#fff',
          border: '1px solid #ddd',
          borderRadius: '4px',
          overflow: 'hidden',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInput: {
          flex: '1',
          padding: '0',
          margin: 'auto 0',
          borderRadius: '0',
          border: '0',
          background: '#fff'
        },
        navInputIcon: {
          margin: 'auto 10px auto 3px',
          color: '#09a3ed',
          fontSize: '1em',
          position: 'relative',
          top: '-1px'
        },
        toggleUploadModalButton: {
          background: '#fff',
          border: '1px solid #09a3ed',
          fontSize: '0.9em',
          color: '#09a3ed',
          borderRadius: '5px',
          padding: '8px 12px',
          margin: 'auto 0 auto 10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          cursor: 'pointer'
        },
        uploadIcon: {
          position: 'relative',
          top: '-2px',
          fontSize: '1em'
        },
        refreshMediaButton: {
          border: '0',
          background: '#fff',
          color: '#09a3ed',
          margin: 'auto 10px',
          cursor: 'pointer'
        },
        noMedia: {
          margin: '100px auto auto',
          display: 'block',
          textAlign: 'center'
        },
        loadMoreButton: {
          padding: '10px 20px',
          background: 'transparent',
          color: '#09a3ed',
          display: 'block',
          margin: '20px auto',
          border: '1px solid #09a3ed',
          borderRadius: '100px',
          cursor: 'pointer'
        }
      }
    };
  },
  mounted() {
    Services.clearActiveMedia();
    Services.getMediaTabs();
    const market = store.getters.getActiveMarket;
    if (market && market._id) {
      Services.getMediaByMarket(market._id, this.selectedMlId, false, false, false, (res) => {
        this.moreMedia = res.more;
      });
    } else {
      Services.getMarkets(markets => {
        Services.getMediaByMarket(markets[0]._id, this.selectedMlId, false, false, false, (res) => {
          this.moreMedia = res.more;
        })
      });
    }
    const el = document.getElementById('scrollWrapper')
    el.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    const el = document.getElementById('scrollWrapper')
    el.removeEventListener('scroll', this.onScroll);
  }
};

</script>
<style lang="scss" scoped>
.rule__control-group.rule__control-group--select:after {
  top: 2px;
}

.rule__control-group {
  width: 200px;

  select {
    width: 200px !important;
  }
}
.view-explanation p.no-bottom-margin {
  margin-bottom: 0;
}
.content-filters-wrapper {
  width: 100%;
  flex: 0 0 auto;
  margin: 0 0 30px 0;
  padding: 0 20px;

  select {
    padding: 5px;
    width: 200px;
  }
}

.media-items-list {
  padding: 0 20px;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
}

#mediaLibraryContainer .mediaCard {
  width: calc(20% - 20px);
  @media all and (max-width: 1600px) {
    height: 200px;
    width: calc(25% - 20px);
  }
  @media all and (max-width: 1280px) {
    height: 200px;
    width: calc(33.33% - 20px);
  }
  @media all and (max-width: 996px) {
    height: 150px;
    width: calc(50% - 20px);
  }

  @media all and (max-width: 640px) {
    width: calc(100% - 20px);
  }
}

.item {
    cursor: move;
}
</style>



// WEBPACK FOOTER //
// src/components/views/MediaLibrary.vue